import authHeader from "../helpers/authHeader";
import userActions from "../actions/userActions";

const getLitigantMenuOptions = (id) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  //console.log("login request");
  return fetch(
    `${process.env.REACT_APP_API_URL}/LitigantMenuOptions`,
    requestOptions
  )
    .then(handleResponse)
    .then((litigantMenu) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //console.log(litigantMenu);
      sessionStorage.setItem("litigantMenu", JSON.stringify(litigantMenu));

      return litigantMenu;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userActions.logout();
        window.Location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const litigantMenuService = {
  getLitigantMenuOptions,
};

export default litigantMenuService;
